<template>
  <div class="view-wrapper">
    <FullCalendarWrapper
      :events="eventsByViewType"
      @change-view-type="changeView"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import { formatCalendarEvents } from '../helpers/events.helper';
import FullCalendarWrapper from './Calendar/FullCalendarWrapper.vue';

defineOptions({
  name: 'EventsCalendarView',
});

const store = useStore();

const viewType = ref(undefined);

const allEvents = computed(() => store.state.events.allEvents);
const sections = computed(() => store.state.events.sections);
const selectedCalendars = computed(() => store.state.events.selectedCalendars);

const eventsByViewType = computed(() => {
  if (!allEvents.value?.length) {
    return [];
  }
  return allEvents.value.reduce(formatCalendarEvents(viewType.value), []);
});

onMounted(() => {
  if (isEmpty(selectedCalendars.value)) {
    store.commit(
      'events/initSelectedCalendars',
      sections.value.flatMap((item) => item.id),
    );
  }
});

function changeView(type) {
  viewType.value = type;
}
</script>

<style lang="scss" scoped>
.view-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: scroll;

  .view-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 24px;

    .view-header-left,
    .view-header-right {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
